/* eslint-disable*/
import React, {Component} from 'react';
import {push} from 'react-router-redux';
import {connect} from 'react-redux';
import moment from 'moment';
import {
    Popup,
    Label,
    Menu,
    Dropdown,
    Image,
    Icon,
    List,
    Modal,
    Header,
    Button
} from 'semantic-ui-react';
import { getUserHomeUrl, setActiveProfile, getDentalPartners } from '../redux/modules/auth';
import { sendFeedback, syncMenuItems, updateDefaultPage, getDefaultPage } from '../redux/modules/account';
import { getDoctorWorkHistory } from '../redux/modules/reports';
import { getHelpNotifications, updateHelpNotifications } from '../redux/modules/help';
import DefaultPageModal from "./DefaultPageModal";
import FeedbackModal from "./FeedbackModal";
import WorkHistoryModal from "./WorkHistoryModal";
import HelpPageModal from "./ManageHelp/HelpPageModal";
import {menusArray, HelpPages, AppUserSetup, FRONTEND_VERSION} from '../constants';
import { performVersionCheck } from '../utils/versionUtils';
import store from 'store2';
import downTimeIcon from "../style/images/downtime-icon.svg";
import {checkIssues} from "../redux/modules/downTimeTracker";
import DownTimeIssuesPopUp from "./ManageHelp/DownTimeIssuesPopUp";
import {getAudits} from "../redux/modules/xrayAudit";
import {isArray} from "lodash";
import {getDoctorWorkHistoryData} from "../utils/commonutils";
import RefreshJobIndicator from './RefreshJobIndicator';

const ReviewNotificationModal = ({ isOpen, onClose, onGoToReviews, onProceedToLoupes, doctorName }) => (
    <Modal open={isOpen} onClose={onClose} size='tiny'>
        <Header content="Clinical Excellence - Assigned Reviews" />
        <Modal.Content>
            <p>
                Dr. {doctorName}, you have reviews that have not been completed.
                <br />
                Reviews should be done by the 10th of the month.
            </p>
        </Modal.Content>
        <Modal.Actions>
            <Button primary onClick={onGoToReviews}>
                Go to reviews
            </Button>
            <Button color='green' onClick={onProceedToLoupes}>
                Proceed to Loupes
            </Button>
        </Modal.Actions>
    </Modal>
);

const MyReviewedChartsNotificationModal = ({ isOpen, onClose, props, onProceedToLoupes, doctorName, onRemindMe }) => (
    <Modal open={isOpen} onClose={onClose} size='tiny'>
        <Header content="Clinical Excellence - My Reviewed Charts" />
        <Modal.Content>
            <p>
                Dr. {doctorName}, you have charts that have been reviewed. You can see the results by going to link below.
            </p>
        </Modal.Content>
        <Modal.Actions style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button primary onClick={() => {
                localStorage.setItem('myReviewedChartsNotificationModalShown', 'true');
                localStorage.removeItem('reminderSetTime');
                props.dispatch(push('/clinical/audit/results'));
            }}>
                Go to reviews
            </Button>
            <Button color={"blue"} onClick={onRemindMe}>
                Remind me
            </Button>
            <Button color='green' onClick={onProceedToLoupes}>
                Proceed to Loupes
            </Button>
        </Modal.Actions>
    </Modal>
);


class MenuExampleSecondary extends Component {
  constructor(props) {
    super(props);
    this.state = { doctorWorkHistory: [], formData: {}, activeItem: '', options: [], image: "", defaultPageModal: false, defaultPage: null, helpPageModal: false, helpPage: null, helpPageId: 0, feedbackModal: false, workHistoryModal: false, message: null, subject: null, notification: false, isNotificationOpen: false, notificationPages: [], appIsDown: false, downTimeIssuesPopUpModal: false,
        openNotificationModal: false, doctorName: "", openNotificationShown: false,
        openMyReviewedChartsNotificationModal: false, remindMe: false, myReviewedChartsModalShown: false, reminderTimeout: null,
        endOfDayTimeout: null, reminderDelay: 2 * 60 * 60 * 1000,
        checkingVersion: true
    }
    this.pageRedirect = this.pageRedirect.bind(this);
    this.versionCheckInterval = null;
  }

  componentDidMount() {
    const { dispatch, user } = this.props;
    if (user){
        dispatch(getDentalPartners(user.id));
        const modalShown = localStorage.getItem('reviewNotificationsModalShown')
        if (!modalShown && user.Doctor && Object.keys(user.Doctor).length) {
            this.fetchUserAudits(user)
        }
        const myReviewedChartsModalShown = localStorage.getItem('myReviewedChartsNotificationModalShown')
        if(!myReviewedChartsModalShown && user.Doctor && Object.keys(user.Doctor).length && moment().date() === 15){
            this.fetchUserReviewedCharts(user);
            const storedTime = localStorage.getItem('reminderSetTime');
            if (storedTime) {
                this.startReminderTimeout(Number(storedTime));
            }
            this.clearReminderAtMidnight();
        }

    }

    this.fetchNotification();
    this.fetchWorkHistory();
    this.getUserDefaultPage();
    this.checkAppVersion();
    // Check version every 5 minutes
    this.versionCheckInterval = setInterval(() => {
      this.checkAppVersion();
    }, 5 * 60 * 1000);
      dispatch(checkIssues('')).then(res => {
          if (res > 0) {
              this.setState({appIsDown: true})
          }
      })

      if(moment().date() !== 15){
          localStorage.removeItem('reminderSetTime');
          if (this.state.reminderTimeout) clearTimeout(this.state.reminderTimeout);
          if (this.state.endOfDayTimeout) clearTimeout(this.state.endOfDayTimeout);
      }
  }

  componentWillUnmount() {
    if (this.state.reminderTimeout) clearTimeout(this.state.reminderTimeout);
    if (this.state.endOfDayTimeout) clearTimeout(this.state.endOfDayTimeout);
    if (this.versionCheckInterval) clearInterval(this.versionCheckInterval);
  }

  checkAppVersion = async () => {
    this.setState({ checkingVersion: true });
    try {
      await performVersionCheck();
    } catch (error) {
      console.error('Version check failed:', error);
    }
    this.setState({ checkingVersion: false });
  }

  getUserDefaultPage = () => {
    const { dispatch, user } = this.props;
    dispatch(getDefaultPage({
      userId: user.id,
      field: AppUserSetup.defaultPage,
      appId: AppUserSetup.appName,
    })).then(res => {
      const useDefault = store.get('initialSign');
      if(useDefault){
        this.props.dispatch(push(res ? `/${res.value}` : '/schedule'));
        store.set('initialSign', false);
        store.set('defaultPage', res ? res.value: '');
      }
    })
  }

    handleClickCDP = async (e) => {
        e.preventDefault();
        const { mycdp_uri} = this.props;
        if(mycdp_uri){
            window.location.href = mycdp_uri;
        }
    };
    fetchNotification = () => {
      const {dispatch} = this.props;
      dispatch(getHelpNotifications())
      .then(res => {
          this.setState({ notificationPages: res });
      })
      .catch(err => {
          console.log('Found error on get help notification list.', err);
      });
    }

    setDoctorHistory = (loggedInDrId, doctorWorkHistory) => {
        const loggedInDrData = getDoctorWorkHistoryData(loggedInDrId, doctorWorkHistory)
        this.setState({doctorWorkHistory:loggedInDrData})
    }

    fetchWorkHistory = () => {
        const {dispatch,user, doctorWorkHistory} = this.props;

        const doctorIds = Object.values(user?.scheduleDoctors ?? {}).map(dr => dr.id);
        const loggedInDrId = user?.Doctor && user?.Doctor?.id || 0

        if(doctorWorkHistory.length > 0) {
            this.setDoctorHistory(loggedInDrId, doctorWorkHistory)
        } else {
            dispatch(getDoctorWorkHistory(doctorIds)).then(data=> {
                this.setDoctorHistory(loggedInDrId, data)
            }).catch(err => {
                console.log('Found error on get work history', err);
            });
        }
    }

    pageRedirect = (e, {text}) => {
        const {user, dispatch} = this.props;
        if (user && user.UdrUsersPermissions) {
            if (this.props.user.UdrUsersPermissions) {
                for (var i = 0; i < this.props.user.UdrUsersPermissions.length; i++) {
                    if (text !== this.props.user.UdrUsersPermissions[i].UdrPermission.role) {
                        continue;
                    }

                    let page = getUserHomeUrl(this.props.user.UdrUsersPermissions[i].roleid);
                    dispatch(setActiveProfile(page));
                    dispatch(push(`/${page}`));
                }
            }
        }
    }

  hideDefaultPageModal =()=>{
    this.setState({defaultPageModal: false});
  };

  openDefaultPage =()=>{
    this.setState({defaultPageModal: true});
  };

  onChangeDefaultPage =(e, {value})=>{
    this.setState({defaultPage: value});
  };

  onClickDefaultPage = () => {
    const { dispatch } = this.props;
    const { defaultPage } = this.state;
    if(this.state.defaultPage) {
      dispatch(updateDefaultPage({
        appId: AppUserSetup.appName,
        field: AppUserSetup.defaultPage,
        value: defaultPage
      }));
      alert('updated default landing page.');
    } else {
      alert('Select default landing page.');
    }
    this.hideDefaultPageModal()
  }

  hideFeedbackModal =()=>{
    this.setState({feedbackModal: false});
  };

  openFeedback =()=>{
    this.setState({feedbackModal: true});
  };
  hideWorkHistoryModal =()=>{
    this.setState({workHistoryModal: false});
  };

  openWorkHistory =()=>{
    this.setState({workHistoryModal: true});
  };

  manageHelp =()=>{
    this.props.dispatch(push(`/manage-help`));
  };

  manageProfile =()=>{
    this.props.dispatch(push(`/manage-profile`));
  };

    onChangeFeedback = (formData) => {
        this.setState({ ...this.state, formData });
    };

  onChangeWorkHistory =(e, {value})=>{
    let state =this.state;
    state[e.target.name] = value;
    this.setState({state});
  };

  onClickFeedbackPage =()=>{
    const { dispatch, user } = this.props;
      const { formData } = this.state;
      const {message, subject} = formData;
      const feedback = {
          subject: formData.subject,
          message: formData.message,
          firstName: user.firstname,
          lastName: user.lastname,
          email: user.email,
          practice: formData.practice,
          file: formData.file,
          dateTime: moment().format('MM/DD/YYYY hh:mm A')
      };

    if(message && subject) {
      dispatch(sendFeedback(feedback));
      alert('Feedback form submitted successfully.');
      this.hideFeedbackModal();
    } else {
      alert('Please enter subject and message.');
    }
  };

  openHelpPage = (pageId) => {
    this.setState({ helpPageModal: true, helpPageId: pageId });
  };

  hideHelpPageModal =()=>{
    this.setState({helpPageModal: false});
  };

  handleOpen = () => {
   this.setState({ isNotificationOpen: true })
  }

  handleClose = () => {
   this.setState({ isNotificationOpen: false })
  }

  onNotificationClick = (pageId, key, open) => {
    const { dispatch, user } = this.props;
    if(open) {
      this.openHelpPage(pageId);
    }
    let notificationPages = this.state.notificationPages;
    if(notificationPages[key]) {
      notificationPages.splice(key, 1);
      this.setState({ notificationPages: notificationPages, isNotificationOpen: (!open) });
      dispatch(updateHelpNotifications({ pageId: pageId, userId: user.id }));
    }
  }

  getNotificationList = (pageIdArray) => {
    let pages = this.state.notificationPages;
    let returnArray = [];
    if(pages && pages.length) {
      pages.forEach( (item, key) => {
        if(pageIdArray.indexOf(item.pageId) >= 0) {
          returnArray.push(
            <List.Item key={key}>
              <List.Content floated='right'>
                <Icon className="primaryColor" name="close" onClick={() => this.onNotificationClick(item.pageId, key)} />
              </List.Content>
              <List.Content>
                <List.Header onClick={() => this.onNotificationClick(item.pageId, key, true)}>{HelpPages[item.pageId].name}</List.Header>
              </List.Content>
            </List.Item>
          );
        }
      });

      return returnArray;
    } else {
      return null;
    }
  }

    checkIfHasPermission =(permission)=>{
        const {user} = this.props;
                if(user && user.UdrUsersPermissions && user.UdrUsersPermissions.length) {
            const foundPermission = user.UdrUsersPermissions
                .filter( item =>item.UdrPermission && item.UdrPermission.role === permission)
            return foundPermission.length > 0
        }
    }

  getUserMenusPages = () => {
    const {user} = this.props;
    let returnMenusArray = [];
    let userRoles = [];
    if(user && user.UdrUsersPermissions && user.UdrUsersPermissions.length) {
      user.UdrUsersPermissions.forEach( item => {
        if(item.UdrPermission)
          userRoles.push(item.UdrPermission.role);
      });
    }

    menusArray.forEach((menu) => {

      // Check if role is assign for menu
      if(menu.role && menu.role.length) {
        let roleExist = false;
        menu.role.forEach( role => {
          if(userRoles.indexOf(role) >= 0) {
            roleExist = true;
          }
        });
        if(roleExist === true) {
          returnMenusArray.push(menu.pageId);
        }
      } else {
        returnMenusArray.push(menu.pageId);
      }

      // Child Menu
      if (menu.subMenus.length > 0) {
        menu.subMenus.forEach((subMenu) => {
          // Check if role is assign for menu
          if(subMenu.role && subMenu.role.length) {
            let roleExist = false;
            subMenu.role.forEach( role => {
              if(userRoles.indexOf(role) >= 0) {
                roleExist = true;
              }
            });
            if(roleExist === true) {
              returnMenusArray.push(subMenu.pageId);
            }
          } else {
            returnMenusArray.push(subMenu.pageId);
          }
        });
      }
    });
    return returnMenusArray;
  }

    openDownTimeTrackerPopUpModal = () => {
        this.setState({downTimeIssuesPopUpModal: true});
    }
    hideDownTimeTrackerPopUpModal = () => {
        this.setState({downTimeIssuesPopUpModal: false});
    }

    fetchUserAudits = (user) => {
        const {dispatch} = this.props;
        this.setState({doctorName: user.Doctor.lastName});
        dispatch(getAudits({auditorUserId: user.Doctor.UserID}))
            .then(audits => {
                const pendingReviewsCount = audits.data && audits.data.filter(review => review.dateCompleted === null);
                if (isArray(pendingReviewsCount) && pendingReviewsCount.length > 0) {
                    this.setState({openNotificationModal: true})
                }
            });
    }

    fetchUserReviewedCharts = (user) => {
        const {dispatch} = this.props;
        this.setState({doctorName: user.Doctor.lastName});

        dispatch(getAudits({auditeeUserId: user.Doctor.UserID})).then((revieweeAudits) => {
            const completedReviewsCount = revieweeAudits.data && revieweeAudits.data.filter(review => review.dateCompleted != null && review.viewed === false) || [];

            if (isArray(completedReviewsCount) && completedReviewsCount.length > 0) {
                this.setState({openMyReviewedChartsNotificationModal: true})
            }
        }).catch(error => {
            console.error("Error fetching audits:", error);
        });
    }
    closeModal = () => {
        localStorage.setItem('reviewNotificationsModalShown', 'true');
        this.setState({openNotificationModal: false});
    };

    closeMyReviewedChartsModal = () => {
        localStorage.setItem('myReviewedChartsNotificationModalShown', 'true');
        localStorage.removeItem('reminderSetTime');
        this.setState({openMyReviewedChartsNotificationModal: false});
    };

    onGoToReviews = () => {
        localStorage.setItem('reviewNotificationsModalShown', 'true');
        this.props.dispatch(push('/clinical/audit/to-do-audits'));
    };

    startReminderTimeout = (startTime) => {
        const timeElapsed = moment().diff(moment(Number(startTime)));
        const remainingTime = this.state.reminderDelay - timeElapsed;
        if (remainingTime > 0) {
            this.reminderTimeout = setTimeout(() => {
                this.setState({ openMyReviewedChartsNotificationModal: true });
            }, remainingTime);
        } else {
            this.setState({ openMyReviewedChartsNotificationModal: true });
        }
    };

    setReminder = () => {
        localStorage.setItem('myReviewedChartsNotificationModalShown', 'true');
        const currentTime = moment().valueOf();
        localStorage.setItem('reminderSetTime', currentTime.toString());
        this.setState({ openMyReviewedChartsNotificationModal: false });
        this.startReminderTimeout(currentTime);
    };

    clearReminderAtMidnight = () => {
        const now = new Date();
        const midnight = new Date();
        midnight.setHours(23, 59, 59, 999);
        const timeUntilMidnight = midnight.getTime() - now.getTime();

        this.endOfDayTimeout = setTimeout(() => {
            localStorage.removeItem('reminderSetTime');
            this.setState({ openMyReviewedChartsNotificationModal: false });
        }, timeUntilMidnight);
    };

    render() {
        const {activeItem, defaultPageModal, feedbackModal, helpPageModal, workHistoryModal,doctorWorkHistory, appIsDown, downTimeIssuesPopUpModal} = this.state
        const {user, logout, listenerFromParent, mycdp_uri,dispatch, syncStatus} = this.props;
        const isSoftwareDevelopment = this.checkIfHasPermission("SOFD")
        const helpUrl = mycdp_uri ? mycdp_uri.replace('?token', `admin/setup/manager-help?token`) : '#';
        let isAdmin = user && user.isAdmin || false;
        let docDetails = (user && user.Doctor) ? user && user.Doctor:'No Data'
        let imgSrc = (user && user.Doctor && user.Doctor.profilePic) ? user.Doctor.profilePic : user.profilePicture;

        let userPagesId = this.getUserMenusPages();
        let notificationList = this.getNotificationList(userPagesId);

        return (
            <React.Fragment>
            <Menu secondary className='mb-0 mt-0'>
              <a onClick={() => this.openFeedback()} className="btnFeedback">
        <small><p>Contact   Provider   Support</p></small>
            </a>
              { defaultPageModal &&
                 <DefaultPageModal hideDefaultPageModal = {this.hideDefaultPageModal}
                                   onChangeDefaultPage = {this.onChangeDefaultPage}
                                   onClickDefaultPage = {this.onClickDefaultPage}/>
              }
              { feedbackModal &&
                 <FeedbackModal hideFeedbackModal = {this.hideFeedbackModal}
                                onChangeFeedback = {this.onChangeFeedback}
                                onClickFeedbackPage = {this.onClickFeedbackPage}/>
              }
              { workHistoryModal &&
                 <WorkHistoryModal hideWorkHistoryModal = {this.hideWorkHistoryModal}
                                    onChangeWorkHistory = {this.onChangeWorkHistory}
                                    onClickFeedbackPage = {this.onClickFeedbackPage}
                                   doctorWorkHistory = {doctorWorkHistory}
                                   DocData = {docDetails}
                                />
              }
              { helpPageModal &&
                 <HelpPageModal hideHelpPageModal = {this.hideHelpPageModal} pageId={this.state.helpPageId} />
              }

              <Menu.Item className='ml-0 mr-0 mr-lg-4 float-left float-lg-none toggle inverted' icon='content'
                         active={activeItem === 'home'}
                         onClick={listenerFromParent}/>
                <span style={{fontSize: '10px', color: '#888', marginLeft: '5px', alignSelf: 'center'}}>
                  {this.state.checkingVersion ? (
                    <><Icon name='spinner' loading size='small' /> Checking for updates...</>
                  ) : (
                    <>v{FRONTEND_VERSION}</>
                  )}
                </span>
                <a onClick={this.handleClickCDP}>
                <img src="/images/logoSmall.png" className="logoSmall" alt="Logo"></img>
                </a>
              <Menu.Menu position='right' className='float-right float-lg-none'>

                { (notificationList && notificationList.length) ? <Popup
                  trigger={<span className="notification"><Icon name="bell outline" className="bellIcon" /><Label circular className="bellIconLabel">{notificationList.length}</Label></span>}
                  content={<List className="notification-list" selection verticalAlign='middle'>{notificationList}</List>}
                  position='bottom center'
                  on='click'
                  open={this.state.isNotificationOpen}
                  onClose={this.handleClose}
                  onOpen={this.handleOpen}
                /> : ""}
                  { appIsDown &&
                      <span className="d-flex align-items-center justify-content-center" onClick={() => this.openDownTimeTrackerPopUpModal()}><img alt="help" className="cursorPointer ml-2" src={downTimeIcon} /></span>
                  }
                  { downTimeIssuesPopUpModal &&
                      <DownTimeIssuesPopUp hideModal={this.hideDownTimeTrackerPopUpModal} applicationList={appIsDown ? appIsDown.appDown: ['']} />
                  }
                  { (isSoftwareDevelopment || isAdmin) && <Menu.Item
                      name='editorials'
                      active={activeItem === 'editorials'}
                  >
                      <span onClick={()=> dispatch(syncMenuItems(menusArray))} className="userName"><Label loading={true} size={"large"}>
                      <Icon loading ={syncStatus} color={"green"} name='sync' />
                          <span className="d-none d-lg-inline-flex d-md-inline-flex">Sync Menus</span>
                  </Label></span>
                  </Menu.Item>}

                  <RefreshJobIndicator />
                  {
                      user && <Menu.Item>
                          <div>
                              <Image src={imgSrc} avatar />
                              <span className="ml15 d-none d-lg-inline-flex d-md-none">{user.firstname} {user.lastname}</span>
                          </div>
                      </Menu.Item>
                  }
                <Dropdown className='setting inverted item mr-0' icon='ellipsis vertical'>
                  <Dropdown.Menu>
                    <Dropdown.Item text='Default Landing Page' onClick={this.openDefaultPage}/>
                    <Dropdown.Item text='Feedback' onClick={this.openFeedback}/>
                    <Dropdown.Item text='WorkHistory' onClick={this.openWorkHistory}/>
                    <Dropdown.Item className="innerDropdown">
                      <Dropdown text='Help'>
                        <Dropdown.Menu>
                          <Dropdown.Item text="OVERVIEW" onClick={() => this.openHelpPage('19')}/>
                          <Dropdown.Item className="mobile-help-link" text="MOBILE" onClick={() => this.openHelpPage('20')}/>
                          {menusArray.map((menu, i) => {
                            return(
                                menu.subMenus.length ?
                                  <Dropdown.Item key={i} className="innerDropdown">
                                    <Dropdown text={menu.title.toUpperCase()}>
                                      <Dropdown.Menu>{ menu.subMenus.map( (subMenu, j) => (userPagesId.indexOf(subMenu.pageId) >= 0) ? <Dropdown.Item key={j} text={subMenu.title.toUpperCase()} onClick={() => this.openHelpPage(subMenu.pageId)}/> : "" ) }</Dropdown.Menu>
                                    </Dropdown>
                                  </Dropdown.Item>
                                :
                                  ((menu && userPagesId.indexOf(menu.pageId) >= 0 && !menu.hide) && <Dropdown.Item key={i} text={menu.title.toUpperCase()} onClick={() => this.openHelpPage(menu.pageId)}/>)
                          );
                          })
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </Dropdown.Item>
                      {isAdmin ? <Dropdown.Item>
                          <a href={helpUrl} target='_blank'>Manage Help</a>
                      </Dropdown.Item> : ""}
                    {isAdmin && <Dropdown.Item text='Version Management' onClick={() => dispatch(push('/admin/version-management'))}/>}
                    {isAdmin && <Dropdown.Item text='Database Visibility' onClick={() => dispatch(push('/admin/database-visibility'))}/>}
                    <Dropdown.Item text='Manage My Profile' onClick={this.manageProfile}/>
                    <Dropdown.Item text='Logout' onClick={logout}/>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>

            </Menu>
                <ReviewNotificationModal
                    isOpen={this.state.openNotificationModal}
                    onClose={this.closeModal}
                    onGoToReviews={this.onGoToReviews}
                    onProceedToLoupes={this.closeModal}
                    doctorName={this.state.doctorName}
                />
                <MyReviewedChartsNotificationModal
                    isOpen={this.state.openMyReviewedChartsNotificationModal}
                    onClose={this.closeMyReviewedChartsModal}
                    props={this.props}
                    onProceedToLoupes={this.closeMyReviewedChartsModal}
                    onRemindMe={this.setReminder}
                    doctorName={this.state.doctorName}
                />
            </React.Fragment>
        );
    }
}

export default connect(state => ({
    user: state.get('auth').get('user'),
    mycdp_uri: state.get('auth').get('mycdp_uri'),
    syncStatus: state.get('account').get('syncStatus'),
    doctorWorkHistory : state.get('reports').get('doctorWorkHistory')
}))(MenuExampleSecondary)